import React from 'react';
import {
  InstantSearch,
  Configure
} from 'react-instantsearch-dom';
import algoliasearch from 'algoliasearch/lite';
import PayoutCard from './PayoutCard';
import {
  Container,
  SearchInput
} from './styles';

const searchClient = algoliasearch(process.env.REACT_APP_ALGOLIA_ID, process.env.REACT_APP_ALGOLIA_KEY);

export default function AlgoliaSearch(props) {
  const {
    connections,
    filters,
    selectedMethod,
    selectPayoutMethod,

  } = props;
  return (
    <Container>
      <InstantSearch
        searchClient={searchClient}
        indexName='integrations'
      >
        <Configure filters={filters} />
        <SearchInput />
        <PayoutCard
          connections={connections}
          selectedMethod={selectedMethod}
          selectPayoutMethod={selectPayoutMethod}
        />
      </InstantSearch>
    </Container>
  );
}
